import type { PagedResultDto } from "@services/dto/pagedResultDto"
import costCenterService from "@services/master-data/accountingData/costCenterService"
import { action, makeAutoObservable, observable } from "mobx"

class CostCenterStore {
  @observable isLoading!: boolean
  @observable tableData!: PagedResultDto<any>
  @observable detailData!: any

  constructor() {
    makeAutoObservable(this)
    this.tableData = { items: [], totalCount: 0 }
  }
  @action
  async createOrUpdate(body: any) {
    this.isLoading = true
    const result = await costCenterService
      .createOrUpdate(body)
      .finally(() => (this.isLoading = false))
    this.detailData = result
    if (!body.id) {
      this.tableData.items.push(result)
    } else {
      this.tableData.items = this.tableData.items.map((x) => {
        if (x.id === body.id) x = result
        return x
      })
    }
  }
  @action
  async initDetail() {
    this.detailData = {
      id: 0,
    }
  }
  @action
  async active(id: number, isActive) {
    this.isLoading = true
    await costCenterService
      .activate(id, isActive)
      .finally(() => (this.isLoading = false))
  }
  @action
  async get(id: number) {
    this.isLoading = true
    const result = await costCenterService
      .get(id)
      .finally(() => (this.isLoading = false))
    this.detailData = result
  }
  @action
  async getAll(params: any) {
    this.isLoading = true
    const result = await costCenterService
      .getAll(params)
      .finally(() => (this.isLoading = false))
    this.tableData = result
  }
  @action
  async export(params: any) {
    this.isLoading = true
    await costCenterService
      .export(params)
      .finally(() => (this.isLoading = false))
  }
  @action
  public import = async (file: File) => {
    this.isLoading = true
    try {
      const result = await costCenterService
        .impport(file)
        .finally(() => (this.isLoading = false))

      return result
    } catch (error) {
      this.isLoading = false
      throw error
    }
  }
}

export default CostCenterStore
